import React, { useState } from "react";
import {
  isPlatform,
  IonCard,
  IonCardTitle,
  IonIcon,
  IonCardContent,
  IonContent
} from "@ionic/react";
import i18n from "i18n";
import Commodity from "../Commodity/Commodity";
import { ComponentProps } from "./types";
import "./AdditionalCommodities.scss";
import CommodityTitle from "../CommodityTitle/CommodityTitle";

export default ({ additionalCommodities }: ComponentProps) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const isMobile = isPlatform("mobile") || isPlatform("mobileweb");

  return (
    <IonCard
      class="additional-commodities"
      style={{ border: isMobile ? "none" : "0.5px solid #dedede" }}
    >
      <IonCardTitle
        onClick={(
          event: React.MouseEvent<HTMLIonCardTitleElement, MouseEvent>
        ) => {
          event.preventDefault();
          event.stopPropagation();
          setExpanded(prev => !prev);
        }}
        className="title"
        data-test="title"
      >
        {i18n.t("Additional Commodities")}
        <IonIcon
          src={expanded ? "assets/icon/minus-icon.svg" : "assets/icon/add.svg"}
        />
      </IonCardTitle>
      {expanded && (
        <IonCardContent>
          {isMobile && <CommodityTitle />}
          <IonContent>
            {additionalCommodities.map((commodity, index) => (
              <Commodity
                commodity={commodity}
                key={`${commodity.commodityDesc}_${index}`}
              />
            ))}
          </IonContent>
        </IonCardContent>
      )}
    </IonCard>
  );
};
